import { graphql, PageProps } from "gatsby";
import { FC } from "react";

import { PageMeta } from "@/components/elements";
import { ErrorLayout, MainLayout } from "@/components/layout";
import { NavbarLink } from "@/features/navbar";

interface QueryResult {
  navbar: {
    frontmatter: {
      navbarLinks: NavbarLink[];
    };
  };
}

const NotFoundPage: FC<PageProps<QueryResult>> = ({ data }: PageProps<QueryResult>) => {
  const { navbarLinks } = data.navbar.frontmatter;

  return (
    <MainLayout navbarLinks={navbarLinks}>
      <PageMeta title={"Unexpected error"} category={"Error"} noIndex />
      <ErrorLayout
        hero={"OOPS!"}
        heading={"Unexpected Error"}
        text={"An unexpected error occurred, click the button below to go back to the homepage."}
      />
    </MainLayout>
  );
};

export const query = graphql`
  query ErrorPageQuery {
    navbar: markdownRemark(fields: { collection: { eq: "navbar" } }) {
      frontmatter {
        navbarLinks {
          label
          url
        }
      }
    }
  }
`;

export default NotFoundPage;
